
<div class="page-header">
  <div>
    <h1>Neues Passwort setzen</h1>
    <p>Wähle ein neues Passwort für deinen DriveMe-Zugang.</p>
  </div>
</div>

<section class="panel">
  <form class="form" [formGroup]="form" (ngSubmit)="submit()">
    <label>
      Neues Passwort
      <input type="password" formControlName="newPassword" autocomplete="new-password">
    </label>

    @if (submitted() && form.controls.newPassword.invalid) {
      <p class="field-error">Bitte ein Passwort mit mindestens 10 Zeichen eingeben.</p>
    }

    <label>
      Passwort wiederholen
      <input type="password" formControlName="confirmPassword" autocomplete="new-password">
    </label>

    @if (submitted() && form.controls.confirmPassword.invalid) {
      <p class="field-error">Bitte das Passwort zur Bestätigung erneut eingeben.</p>
    } @else if (submitted() && form.hasError('passwordsMismatch')) {
      <p class="field-error">Die Passwörter stimmen nicht überein.</p>
    }

    @if (message()) {
      <p class="info-message">{{ message() }}</p>
    }

    @if (error()) {
      <p class="field-error">{{ error() }}</p>
    }

    <button class="primary-button" type="submit" [disabled]="loading() || !token()">
      {{ loading() ? 'Wird gespeichert...' : 'Passwort speichern' }}
    </button>

    <a class="table-link" routerLink="/login">Zur Anmeldung</a>
  </form>
</section>
  
